import React from 'react';
import classNames from 'classnames';
import EditButton from 'components/v2/buttons/EditButton';
const numericCols = ['numericColumn', 'rightAligned'];
export default function cellRenderer(props) {
    const handleClick = (e) => {
        e.stopPropagation();
        e.preventDefault();
        props.api.startEditingCell({
            rowIndex: props.node.rowIndex,
            colKey: props.column.getId(),
        });
    };
    const formattedValue = props.formatValue(props.getValue());
    if (!props.colDef.editable) {
        return formattedValue !== null && formattedValue !== void 0 ? formattedValue : '';
    }
    const numericType = numericCols.includes(props.colDef.type);
    const className = classNames('flex items-center space-x-2', {
        'justify-end': numericType,
        'justify-between': !numericType,
    });
    return (React.createElement("div", { "data-testid": "div-5b07811e", className: className, title: formattedValue },
        React.createElement("div", { "data-testid": "div-771b5451", className: "my-0 truncate" }, formattedValue),
        React.createElement(EditButton, { dataTestId: "EditButton-877b4f5e", size: "small", onClick: handleClick })));
}
